import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import TaxType from 'modules/finance/components/TaxType'

const TaxTypeDetail = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { id } = useParams()

  if (!id) {
    navigate(navigation.settings.finance.accounting.taxType.fullPath())
    return null
  }

  return <TaxType taxTypeId={id} />
}

export default TaxTypeDetail
